/**
 * Phase 13a — pure tRPC client configuration helpers.
 *
 * The `createTrpcClient` factory itself ([client.ts](./client.ts))
 * composes the runtime `httpBatchLink` against this module's pure
 * helpers. Splitting the URL / header composition out keeps the
 * unit tests free of `fetch` / `AbortController` plumbing and makes
 * the contract crystal clear: given a base URL + an optional Clerk
 * token, produce the tRPC URL and the request headers.
 *
 * Auth is single-header `Authorization: Bearer <token>`, matching
 * Phase 12b's `joseClerkJwtVerifier` (which reads from the
 * `authorization` header). When the token is absent the header is
 * simply omitted; the API's anonymous procedures handle the unauth
 * path.
 */

export const buildTrpcUrl = (apiBaseUrl: string): string => {
  // Strip any trailing slashes so we don't double-up when joining.
  const trimmed = apiBaseUrl.replace(/\/+$/, "");
  return `${trimmed}/trpc`;
};

export type TrpcRequestHeaders = Readonly<Record<string, string>>;

export const buildAuthHeaders = (
  token: string | undefined
): TrpcRequestHeaders => {
  if (token === undefined) return {};
  const trimmed = token.trim();
  if (trimmed.length === 0) return {};
  return { Authorization: `Bearer ${trimmed}` };
};
